import { render, staticRenderFns } from "./_CustomExtensionForm.vue?vue&type=template&id=215d59de&scoped=true&"
import script from "./_CustomExtensionForm.vue?vue&type=script&lang=ts&"
export * from "./_CustomExtensionForm.vue?vue&type=script&lang=ts&"
import style0 from "./_CustomExtensionForm.vue?vue&type=style&index=0&id=215d59de&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "215d59de",
  null
  
)

export default component.exports